/**
 * 학교사 데이터
 */
const SchoolHistoryData = [
    {
        "book_id": 10806,
        "book_title": "(同德女子高等普通學校) 同德二十年-同德女學校創立二十周年紀念祝賀會 ",
        "book_title_ko": "(동덕여자고등보통학교) 동덕20년-동덕여학교창립이십주년기념축하회 ",
        "publish_date": "1928.10.06",
        "publish_year": 1928,
        "publish_month": 10,
        "publish_day": 6,
        "publisher": "白南奎   同德女子高等普通學校",
        "publisher_ko": "백남규   동덕여자고등보통학교",
        "library": "△",
        "school_id": 52883,
        "primaryname": "同德女子高等普通學校",
        "primaryname_ko": "동덕여자고등보통학교"
    }

]

export default SchoolHistoryData;